import { CustomRenderers } from '../DocumentRenderer';

export const listRenderer: NonNullable<CustomRenderers['block']>['list'] = props => {
	const { type, children } = props!;

	const listItems = children.map((child, index) => {
		return <li key={index}>{child}</li>;
	});

	return type === 'ordered' ? <ol className="list-decimal pl-4">{listItems}</ol> : <ul className="list-disc pl-4">{listItems}</ul>;
};
